<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <div>
          <div style="overflow: hidden" @click="UploadImg1">
            <div class="dashed" v-if="Src1 == '' || Src1 == null">
              <div class="d-flex justify-center py-14">
                <div class="pa-14">
                  <camerasvg />
                </div>
              </div>
            </div>

            <v-card v-model="UploadedImage1" v-else>
              <v-img :src="Src1" ref="Image1" height="300"></v-img>
            </v-card>
          </div>

          <input
            type="file"
            accept="image/png, image/gif, image/jpeg"
            style="display: none"
            ref="Img1"
            @change="SetImage1"
          />
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12" md="6">
            <div>
              <div style="" @click="UploadImg2">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground2"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src2 == '' || Src2 == null"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card class="custom-card" v-model="UploadedImage2" v-else>
                  <v-img :src="Src2" ref="Image2" height="185"></v-img>
                  <div class="close-icon" @click.stop="removeImage('secondary1')">x</div>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img2"
                @change="SetImage2"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div>
              <div style="" @click="UploadImg3">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground3"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src3 == '' || Src3 == null"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card class="custom-card" v-model="UploadedImage3" v-else>
                  <v-img :src="Src3" ref="Image3" height="185"></v-img>
                  <div class="close-icon" @click.stop="removeImage('secondary2')">x</div>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img3"
                @change="SetImage3"
              />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="">
              <div style="" @click="UploadImg4">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground4"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src4 == '' || Src4 == null"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card class="custom-card" v-model="UploadedImage4" v-else>
                  <v-img :src="Src4" ref="Image4" height="185"></v-img>
                  <div class="close-icon" @click.stop="removeImage('secondary3')">x</div>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img4"
                @change="SetImage4"
              />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="">
              <div style="" @click="UploadImg5">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground5"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src5 == '' || Src5 == null"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card class="custom-card" v-model="UploadedImage5" v-else>
                  <v-img :src="Src5" ref="Image5" height="185"></v-img>
                  <div class="close-icon" @click.stop="removeImage('secondary4')">x</div>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img5"
                @change="SetImage5"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CameraBorderBoxSvg from "../../assets/SvgIcons/CameraborderboxSvg.vue";
import Camerasvg from "../../assets/SvgIcons/camerasvg.vue";
export default {
  props: ["storeImage"],
  name: "BlogImageUploaderComponent",
  components: { CameraBorderBoxSvg, Camerasvg },
  mounted() {
    if (this.storeImage) {
      console.log(this.storeImage);
      setTimeout(() => {
        console.log(this.storeImage);
        this.Src1 = this.storeImage.CoverImage;
        this.Src2 = this.storeImage.Image1;
        this.Src3 = this.storeImage.Image2;
        this.Src4 = this.storeImage.Image3;
        this.Src5 = this.storeImage.Image4;
      }, 100);
    }
  },

  data() {
    return {
      ThumbnailImg: "",
      BannerImg: "",
      Image1: "",
      Image2: "",
      Image3: "",

      svgBackground1: true,
      UploadedImage1: false,
      img1: {},
      Src1: null,

      svgBackground2: true,
      UploadedImage2: false,
      img2: {},
      Src2: null,

      svgBackground3: true,
      UploadedImage3: false,
      img3: {},
      Src3: null,

      svgBackground4: true,
      UploadedImage4: false,
      img4: {},
      Src4: null,

      svgBackground5: true,
      UploadedImage5: false,
      img5: {},
      Src5: null,
    };
  },
  methods: {
    removeImage(imageType) {
      switch (imageType) {
        case 'secondary1':
          this.Src2 = null;
          this.$refs.Image2.value = "";
          this.$emit("SetImage1", "");
          break;
        case 'secondary2':
          this.Src3 = null;
          this.$refs.Image3.value = "";
          this.$emit("SetImage2", "");
          break;
        case 'secondary3':
          this.Src4 = null;
          this.$refs.Image4.value = "";
          this.$emit("SetImage3", "");
          break;
        case 'secondary4':
          this.Src5 = null;
          this.$refs.Image5.value = "";
          this.$emit("SetImage4", "");
          break;
      }
    },
    UploadImg1() {
      this.$refs.Img1.click();
    },

    SetImage1() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src1 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetCoverImage", {
          file: this.$refs.Img1.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img1.files[0]);
    },
    UploadImg2() {
      this.$refs.Img2.click();
    },
    SetImage2() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src2 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetImage1", {
          file: this.$refs.Img2.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img2.files[0]);
    },

    UploadImg3() {
      this.$refs.Img3.click();
    },

    SetImage3() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src3 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetImage2", {
          file: this.$refs.Img3.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img3.files[0]);
    },
    UploadImg4() {
      this.$refs.Img4.click();
    },
    SetImage4() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src4 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetImage3", {
          file: this.$refs.Img4.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img4.files[0]);
    },
    UploadImg5() {
      this.$refs.Img5.click();
    },
    SetImage5() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src5 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetImage4", {
          file: this.$refs.Img5.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img5.files[0]);
    },
  },
};
</script>

<style scoped>
.dashed {
  border: 0.2px dashed #cacacd;
  border-style: 0.2px dashed;
  border-radius: 10px;
  max-height: 400px;
  opacity: 0.48;
  align-items: center;
}

.svgBackgroundSection {
}
h1 {
  font-family: "DM Sans";
  font-size: 30px;
  font-weight: 400;
  line-height: 39px;
}
.custom-card {
  position: relative;
}
.close-icon {
  position: absolute;
  z-index: 20;
  padding-bottom: 3px;
  top: -9px;
  right: -9px;
  cursor: pointer;
  display: flex;
  height: 20px;
  width: 20px;
  font-size: 25px;
  justify-content: center;
  align-items: center;
  line-height: 0px;
  border-top-left-radius: 20%;
  border-top-right-radius: 20%;
  background-color: rgba(170, 168, 168, 0.704);
}
/* .check {
  background-image: url("../../assets/css/rect.svg");
  background-repeat: no-repeat;
  background-size: ;
  display: flex;
  align-items: center;
} */
</style>
